import { render, staticRenderFns } from "./VehicleExpenses.vue?vue&type=template&id=16f84c02&scoped=true"
import script from "./VehicleExpenses.vue?vue&type=script&lang=js"
export * from "./VehicleExpenses.vue?vue&type=script&lang=js"
import style0 from "./VehicleExpenses.vue?vue&type=style&index=0&id=16f84c02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f84c02",
  null
  
)

export default component.exports